var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLessonIc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#98BDBD",
    strokeWidth: 2.083,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.083 2.583H5.75a2.083 2.083 0 00-2.083 2.084v16.666a2.083 2.083 0 002.083 2.084h12.5a2.083 2.083 0 002.083-2.084v-12.5l-6.25-6.25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.083 2.583v6.25h6.25M16.167 14.042H7.833M16.167 18.208H7.833M9.917 9.875H7.833"
  }))));
}
export default SvgLessonIc;